import React, { useState, useEffect } from "react";
import axios from 'axios';
import { Table, Button, Tag, Input, Row, Col } from 'antd';
import Loader from '../util/Loader';
import './Main.css';
import TopNav from './TopNav';
import MainNav from './MainNav';
import LoginCheck from '../util/LoginCheck';
import DecodeData from '../util/DecodeData';
import LoginFail from '../util/LoginFail';
import SelectCenter from "../util/SelectCenter";
import Filter from '../util/Filter';
import { useSelector, useDispatch } from 'react-redux';
import PopupComponent from "../util/ReservationPopup";
import moment from 'moment';
import setup from '../setup';
import GetApiHost from "../util/GetApiHost";
import pr from "../util/pr";

var clear = false;
var name = '';
var filterMode = {
    name : true,
    phone : false
}

let storage = {
    nameKeyword : '',
    phoneKeyword : '',
    teacherCount : 0,
    popupData : []
}

let searchData = {};

export default function Rating() {

    const [showPopup, setShowPopup] = useState(false);
    const [selectedCenter, setSelectedCenter] = useState('');
    const [dataSource, setDataSource] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const data = useSelector(state => state.data);
    const dispatch = useDispatch();    

    const columns = [
        {
            title : '구분',
            dataIndex : 'pt_type',
            key : 'pt_type',
            align: 'center',
            width: 100
        },
        {
            title : '센터명',
            dataIndex : 'cname',
            key : 'cname',
            align: 'center',
            width: 200,
        },
        {
            title : '수업일',
            dataIndex : 'class_date_time',
            key : 'class_date_time',
            sorter: (a, b) => moment(a.class_date_time, 'YYYY-MM-DD HH:mm a').valueOf() - moment(b.class_date_time, 'YYYY-MM-DD HH:mm a').valueOf(),
            align:'center',
            width:200
        },
        {
            title : '강사명',
            dataIndex : 'teacher',
            key : 'teacher',
            align:'center',
            width:100
        },
        {
            title : '고객명',
            dataIndex : 'name',
            key : 'name',
            align:'center',
            width:100
        },
        {
            title : '상태',
            dataIndex : 'final_state',
            key : 'final_state',
            render : final_state => {
                let color = '';
                if(final_state === '예약완료'){
                    color = 'blue';
                }else if(final_state === '평가요청'){
                    color = 'red';
                }else if(final_state === '평가완료'){
                    color = 'green';
                // }else if(final_state === '결석'){ 
                //     color = 'gray';
                }else if(final_state === '결석'){
                    color = 'purple'
                }else if(final_state === '미평가'){
                    color = 'purple'
                }
                return (
                    <Tag color={color}>
                        {final_state}
                    </Tag>
                )
            },
            align:'center',
        },
        {
            title : '등록일',
            dataIndex : 'regdate',
            key : 'regdate',
            render : regdate => {
                return moment(regdate).format('YYYY-MM-DD HH:mm')
            },
            align:'center',
            width: 190
        }
    ];

    const onClickRow = (record) => {
        return {
            onClick : () => {
                openPopup("edit", record)
            }
        }
    }
    
    function openPopup(mode, data) {
        setShowPopup(true);
        storage.popupMode = mode;
        storage.popupData = data;
    }

    function handleSelectedCenter(cid){
        setSelectedCenter(cid);
    }

    function handleClear(){
        storage.nameKeyword = '';
        clear = true;
        getDataSource();
    }

    function handleFilter(filterData){
        storage.nameKeyword = filterData.nameKeyword;
        getDataSource();
    }

    function closePopup(isUpdated) {
        setShowPopup(false);
        if(isUpdated === "updated"){
            getDataSource()
        }
    }

    async function getDataSource(){

        
        let temp_cid = '';
        if(data.cid !== 'root'){
            temp_cid = data.cid
        }else{
            temp_cid = selectedCenter
        }
                
        const host = GetApiHost();
        const result = await axios.post(host + '/gympass_admin/get_reservation', {
            cid: temp_cid,
            uname: searchData.uname,
            tname : searchData.tname,
            date: searchData.date,            
        })
        setDataSource(result.data.rows);
        
    }

    async function main() {
        const result = await LoginCheck(data.url);
        if(result === "Y"){
            const decodeResult = await DecodeData(data.url);
            dispatch({type:'SET', name:"CID", value:decodeResult.cid});
            dispatch({type:'SET', name:"LEVEL", value:decodeResult.level});
            getDataSource();
            setInterval(()=>{setIsLoading(false)}, 300); 
        }else{
            LoginFail();
        }
    }

    useEffect(()=>{
        main();   
    },[]);

    useEffect(()=>{
        if(data.cid === "root"){
            getDataSource();
        }
    },[selectedCenter]);

    if (isLoading) return (
        <main className="main-container">
        <TopNav />
        <div className="content-wrapper">
        <MainNav />
        <Loader />
        </div>
        </main>
    )

    const onChangeDate = e => {        
        searchData.date = e.target.value;
    }    

    const onChangeTname = e => {
        searchData.tname = e.target.value;        
    }    
    
    const onChangeUname = e => {
        searchData.uname = e.target.value;        
    }       
    
    const onSearch = () => {
        getDataSource();        
    }

    const onReset = () => {
        window.location.reload();
    }

    return (
        <main className="main-container">
            <TopNav />
            <div className="content-wrapper">
            <MainNav />
            <div className="content-inner">
            <h3 style={{display : "inline-block"}}>예약 관리</h3>
            
            <div>
            <Button size="small" onClick={()=>window.location.href='/reservationBoard'}>예약보드</Button> <Button size="small" disabled={true}>예약관리</Button>
            </div>
            
            <div className="content-component">
                <div className="content-header">
                <div></div>
                <SelectCenter 
                    onSelectedCenter={handleSelectedCenter}
                />
                </div>
                <div className="content-body">
                    <div className="table-header">
                        <div></div>
                        <div style={{display : "inline-flex"}}>                        
                        <Row>
                            <Col><Input placeholder="수업일" style={{ width: 150}} onChange={onChangeDate} allowClear/></Col>
                            <Col><Input placeholder="강사명" style={{ width: 150}} onChange={onChangeTname} allowClear/></Col>
                            <Col><Input placeholder="고객명" style={{ width: 150}} onChange={onChangeUname} allowClear/></Col>
                            <Col><Button type="primary" onClick={onSearch}>검색</Button></Col>
                            <Col><Button onClick={onReset}>초기화</Button></Col>
                        </Row>
                        </div>
                    </div>
                    <div className="table-body cursor">
                    <Table dataSource={dataSource} columns={columns} onRow={onClickRow} rowKey="seq"/>
                    </div>
                </div>
            </div>
            {showPopup ? 
            <PopupComponent
                data = {storage.popupData}
                mode = {storage.popupMode}
                closePopup={closePopup}
            />
            : null
            }
            </div>
            </div>
        </main>
    )
}